import { type FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { type DesignSeriesEditorial_iconicDesignSeriesPage$data } from './__generated__/DesignSeriesEditorial_iconicDesignSeriesPage.graphql';
import EditorialModule from 'dibs-editorial-module/exports/EditorialModule';

import styles from './DesignSeriesEditorial.scss';

type Props = {
    iconicDesignSeriesPage: DesignSeriesEditorial_iconicDesignSeriesPage$data;
};

const DesignSeriesEditorialComponent: FC<Props> = ({ iconicDesignSeriesPage }) => {
    const editorialArticles = iconicDesignSeriesPage?.editorialArticles;
    if (!editorialArticles?.totalResults) {
        return null;
    }
    return (
        <div className={styles.container}>
            <EditorialModule editorialArticles={editorialArticles} launchOrigin="design series" />
        </div>
    );
};

export const DesignSeriesEditorial = createFragmentContainer(DesignSeriesEditorialComponent, {
    iconicDesignSeriesPage: graphql`
        fragment DesignSeriesEditorial_iconicDesignSeriesPage on IconicDesignSeriesPage {
            editorialArticles(first: 8) {
                totalResults
                ...EditorialModule_editorialArticles
            }
        }
    `,
});
